import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "knowledge/";

class KnowledgeBaseService {
  getKnowledgeBase(internal = false) {
    return axios.get(ENDPOINT_URL, {
      headers: authHeader(),
      params: { internal },
    });
  }

  uploadDocument(file, name, internal = false) {
    const formData = new FormData();
    formData.append("file", file);
    if (name) formData.append("name", name);
    formData.append("internal", internal);
    return axios.post(ENDPOINT_URL + "upload", formData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  }

  addUrl(url, name, internal = false) {
    return axios.post(
      ENDPOINT_URL + "url",
      { url, name, internal },
      { headers: authHeader() },
    );
  }

  deleteKnowledgeBase(id) {
    return axios.delete(ENDPOINT_URL + id, { headers: authHeader() });
  }

  getKnowledgeBasePairs(id) {
    return axios.get(ENDPOINT_URL + id + "/pairs", { headers: authHeader() });
  }

  deletePair(docId, pairId) {
    return axios.delete(ENDPOINT_URL + docId + "/pairs/" + pairId, {
      headers: authHeader(),
    });
  }

  movePair(docId, pairId) {
    return axios.post(
      ENDPOINT_URL + docId + "/pairs/" + pairId + "/move",
      {},
      { headers: authHeader() },
    );
  }

  generateEmbeddings(id) {
    return axios.post(
      ENDPOINT_URL + id + "/generate",
      {},
      { headers: authHeader() },
    );
  }

  reprocessKnowledgeBase(id) {
    return axios.post(
      ENDPOINT_URL + id + "/reprocess",
      {},
      { headers: authHeader() },
    );
  }
}

export default new KnowledgeBaseService();
